module.exports = __webpack_public_path__ + "static/turquia-002-185f039214356b071d3a5e6af321d94d.jpg";